import { render, staticRenderFns } from "./MareLiberumSet.vue?vue&type=template&id=87957fd8&scoped=true&"
import script from "./MareLiberumSet.vue?vue&type=script&lang=js&"
export * from "./MareLiberumSet.vue?vue&type=script&lang=js&"
import style0 from "./MareLiberumSet.vue?vue&type=style&index=0&id=87957fd8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87957fd8",
  null
  
)

export default component.exports